function routes($stateProvider) {
    $stateProvider
        .state("mini.newBasicInfo", {
            name: "miniNewBasicInfo",
            url: "/basic-info",
            views: {
                content: { template: "<step-basic-info></step-basic-info>" },
            },
        })
        .state("mini.basicInfo", {
            name: "miniBasicInfo",
            url: "/:id/basic-info",
            views: {
                content: { template: "<step-basic-info></step-basic-info>" },
            },
        })
        .state("mini.learningGoals", {
            name: "miniLearningGoals",
            url: "/:id/learning-goals",
            views: {
                content: {
                    template: "<step-learning-goals></step-learning-goals>",
                },
            },
        })
        .state("mini.learningEngagement", {
            name: "miniLearningEngagement",
            url: "/:id/learning-engagement",
            views: {
                content: {
                    template:
                        "<step-learning-engagement></step-learning-engagement>",
                },
            },
        })
        .state("mini.newMiniPedagogicalApproach", {
            name: "newMiniPedagogicalApproach",
            url: "/:id/mini-pedagogical-approach/:activeParameter",
            views: {
                content: {
                    template:
                        "<mini-pedagogical-approach></mini-pedagogical-approach>",
                },
            },
            params: {
                activeParameter: "1",
            },
        })
        .state("mini.conclusions", {
            name: "miniConclusions",
            url: "/:id/conclusions",
            views: {
                content: { template: "<step-conclusions></step-conclusions>" },
            },
        })
        .state("mini.gdpr", {
            name: "miniGdpr",
            url: "/:id/gdpr",
            views: {
                content: { template: "<step-gdpr></step-gdpr>" },
            },
        })
        .state("mini.publish", {
            name: "miniPublish",
            url: "/:id/publish",
            views: {
                content: { template: "<step-publish></step-publish>" },
            },
        });
}

routes.$inject = ["$stateProvider"];

export default routes;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/miniEvaluationRoutes.js